/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfNameValueDto } from "../models/AjaxResponseOfListOfNameValueDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class SoCarraoAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getMakes(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/socarrao/get-makes",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getModels({
    makeId,
  }: {
    makeId?: number;
  }): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/socarrao/get-models",
      query: {
        makeId: makeId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getOptionals(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/socarrao/get-optionals",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getFuelType(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/socarrao/get-fuel-types",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getColors(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/socarrao/get-colors",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getGears(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/socarrao/get-transmissions",
    });
  }
}
